import React, { useCallback } from "react";
import { useTheme } from "../contexts/ThemeContext";

// ─── Banner Ad (AdSense compliant) ───
export function AdBanner({ slot = "top", className = "" }) {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <div
      data-testid={`ad-banner-${slot}`}
      className={`w-full overflow-hidden transition-all ${className}`}
    >
      {/* Clear "Advertisement" label - AdSense requirement */}
      <p className={`text-[9px] ${isDark ? "text-slate-600" : "text-slate-400"} text-center mb-1`}>
        — Publicité —
      </p>
      {/* Google AdSense auto ad slot */}
      <div
        id={`ad-slot-${slot}`}
        className="flex items-center justify-center py-4 px-4 rounded-xl"
        style={{
          minHeight: "90px",
          background: isDark ? "rgba(30, 41, 59, 0.3)" : "rgba(0,0,0,0.02)",
          border: isDark ? "1px solid rgba(255,255,255,0.03)" : "1px solid rgba(0,0,0,0.03)",
        }}
      >
        {/* Placeholder - Google AdSense will fill this automatically once approved */}
        <p className={`text-[10px] ${isDark ? "text-slate-600" : "text-slate-400"}`}>
          Espace publicitaire
        </p>
      </div>
    </div>
  );
}

// ─── Hook: useAds ───
export function useAds(isPremium) {
  const showBanners = !isPremium;
  return { showBanners };
}
